import { WalletIcon } from "../../../crypto/icons";
import AddAccountModal from "../../Modals/AddAccount/AddAccountModal";

const EmptyNewCryptoAccounts = () => (
  <div className="flex h-[320px] flex-col items-center justify-center p-6 text-center">
    {/* Icon */}
    <div className="mb-4 flex items-center justify-center border bottom-3 border-text-secondary p-3 rounded-full">
      <WalletIcon className="h-9 w-9 text-text-secondary opacity-80" />
    </div>

    {/* Title & Description */}
    <h3 className="mb-1.5 text-base font-semibold text-text-primary">
      No Crypto Accounts Yet
    </h3>
    <p className="mb-6 max-w-[280px] text-xs font-normal leading-relaxed text-text-secondary">
      You don't have any active crypto accounts. Create or request an account to start managing your digital assets.
    </p>

    {/* Action Button */}
    <AddAccountModal crypto={true}>
      <button
        type="button"
        // className="inline-flex items-center gap-2 rounded-lg bg-[#4ab932] px-4 py-2.5 text-xs font-semibold text-white shadow-sm transition-all hover:bg-[#3ea329] active:scale-[0.98]"
        className="group inline-flex items-center gap-2 justify-center px-4 py-[9px] rounded-[8px] 
        border border-primary-300 bg-primary-300 text-sm font-medium text-white hover:border-primary-300 
        hover:bg-primary-300/90 custom-transition"
      >
        <svg
          className="size-3.5 stroke-[2.5]"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
        >
          <path d="M12 5v14M5 12h14" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Add Crypto Account
      </button>
    </AddAccountModal>
  </div>
);

export default EmptyNewCryptoAccounts;